import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { authBackendEndPointToken } from '../app.config';
import { DisableSortParam, DisableCountParam } from '../loading.interceptor';

export interface OAuthStartResponse {
  authUrl: string;
}

export interface ConnectionStatus {
  connected: boolean;
  expiresAt: string | null;
}

@Injectable({ providedIn: 'root' })
export class IntegrationsService {
  private http = inject(HttpClient);
  private baseUrl = inject(authBackendEndPointToken);

  private readonly noFhirParamsContext = new HttpContext()
    .set(DisableSortParam, true)
    .set(DisableCountParam, true);

  getWebexAuthUrl(): Observable<OAuthStartResponse> {
    return this.http.get<OAuthStartResponse>(`${this.baseUrl}/api/webex/oauth/start`, {
      context: this.noFhirParamsContext
    });
  }

  getGoogleAuthUrl(): Observable<OAuthStartResponse> {
    return this.http.get<OAuthStartResponse>(`${this.baseUrl}/api/google/oauth/start`, {
      context: this.noFhirParamsContext
    });
  }

  getTeamsAuthUrl(): Observable<OAuthStartResponse> {
    return this.http.get<OAuthStartResponse>(`${this.baseUrl}/api/teams/oauth/start`, {
      context: this.noFhirParamsContext
    });
  }

  getWebexStatus(): Observable<ConnectionStatus> {
    return this.http.get<ConnectionStatus>(`${this.baseUrl}/api/webex/status`, {
      context: this.noFhirParamsContext
    });
  }

  getGoogleStatus(): Observable<ConnectionStatus> {
    return this.http.get<ConnectionStatus>(`${this.baseUrl}/api/google/status`, {
      context: this.noFhirParamsContext
    });
  }

  getTeamsStatus(): Observable<ConnectionStatus> {
    return this.http.get<ConnectionStatus>(`${this.baseUrl}/api/teams/status`, {
      context: this.noFhirParamsContext
    });
  }
}